module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "toc-header"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Acknowledgements"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgements")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter01"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" The Foot Guards")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" The Line Infantry")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" The Scottish Infantry")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" The Light Infantry")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Royal Veteran Battalions and Fencible Regiments")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" The British Troops in Canada")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" The British Troops in the West Indies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" The British Troops in Africa and Australia")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" The British Troops in India")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" Foreign Troops in British Service")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])]), _vm._v(" The King’s German Legion")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-hang"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])]), _vm._v(" Uniforms and Equipment")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Bib",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-132b06ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0